import { render, staticRenderFns } from "./PcCheckbox.vue?vue&type=template&id=628c46ac&scoped=true"
import script from "./PcCheckbox.vue?vue&type=script&lang=js"
export * from "./PcCheckbox.vue?vue&type=script&lang=js"
import style0 from "./PcCheckbox.vue?vue&type=style&index=0&id=628c46ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c46ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
